import Usuario from "model/administracao/cadastro/Usuario";
import Estagio from "./Estagio";
import { BaseEditModel } from "../BaseEditModel";

export default class EstagioUsuario implements BaseEditModel {
    id: number;
    key: string | null = "";
    sequencial: number | null = 0;
    estagio: Estagio;
    usuario: Usuario;

    constructor(
        id: number = 0, 
        estagio: Estagio = new Estagio(),
        usuario: Usuario = new Usuario(),

    ) {
        this.id = id;
        this.estagio = estagio;
        this.usuario = usuario;
    }
}